<script lang="ts">
  import { observeTagOverflow } from "../../_logic/tag-overflow"
  import StatusTag from "@kontextwerk/web-sdk/ui/display/StatusTag.svelte"
  import {
    buildRichTooltip,
    tooltipText,
    RICH_TOOLTIP_CLASS,
  } from "../../../../../_shared/_logic/rich-tooltips"
  import type { PropertyObjectTagPresentation } from "../../_logic/object-tags"

  type Props = {
    tag: PropertyObjectTagPresentation
    tooltipContent?: string | null
    disabled?: boolean
  }

  const { tag, tooltipContent = null, disabled = false }: Props = $props()
  let overflowing = $state(false)
</script>

<span
  class:disabled
  use:observeTagOverflow={(value) => {
    overflowing = value
  }}
>
  <StatusTag
    variant="neutral"
    size="sm"
    label={tag.label}
    subLabel={tag.subLabel ?? undefined}
    color={tag.color}
    icon={tag.icon}
    tooltipContent={buildRichTooltip([
      overflowing ? tooltipText([tag.label, tag.subLabel].filter(Boolean).join(" · ")) : null,
      tooltipContent,
    ])}
    tooltipHtml={true}
    tooltipClassName={RICH_TOOLTIP_CLASS}
    disableTitle={true}
  />
</span>

<style lang="less">
  span {
    display: inline-flex;
    max-width: 100%;
  }

  span :global(.status-tag__main-label),
  span :global(.status-tag__sub-label) {
    max-width: min(22rem, 100%);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  span.disabled {
    opacity: 0.58;
  }
</style>
